<template>
  <div>
    <el-dialog
      title="Preview"
      :visible.sync="dialogVisible"
      width="40%"
      class="headercolor"
    >
      <div></div>
    </el-dialog>
    <div class="lg:py-16 lg:px-24 md:px-16 px-4">
      <h4 class="text-dark lg:text-4xl md:text-3xl text-2xl mt-2 font-semibold">
        Future Trends
      </h4>
      <div
        class="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-6 lg:mt-8 md:mt-6 mt-5"
      >
        <div
          class="border rounded-xl overflow-hidden cursor-pointer"
          v-for="(i, index) in tableData"
          :key="index"
        >
          <!-- <img
            v-if="i.hasOwnProperty('fileType') && i.fileType == 'Url'"
            :src="`${$imageURL}/caregiversaathi/default/dummy%20image.jpg`"
            class="h-52 w-full object-cover"
          />
          <img
            @click="openFile(i)"
            v-else-if="i.hasOwnProperty('fileType') && i.fileType == 'Image'"
            :src="`${$imageURL}/${i.file}`"
            class="h-52 w-full object-cover"
          />
          <img
            @click="openFile(i)"
            v-else-if="i.hasOwnProperty('fileType') && i.fileType == 'Document'"
            src="https://nimbuscluster.blob.core.windows.net/server01/taskmanager/images.png"
            class="h-52 w-full object-cover"
          /> -->

          <video
            v-if="i.hasOwnProperty('fileType') && i.fileType == 'Video'"
            :src="`${$imageURL}/${i.file}`"
            class="h-52 w-full object-cover cursor-pointer"
          />
          <img
            v-else-if="i.hasOwnProperty('coverImage')"
            :src="`${$imageURL}/${i.coverImage}`"
            class="h-52 w-full object-cover cursor-pointer"
            @click="openFile(i)"
          />
          <img
            v-else
            :src="`${$imageURL}/caregiversaathi/default/dummy%20image.jpg`"
            class="h-52 w-full object-cover cursor-pointer"
            @click="openFile(i)"
          />

          <div class="lg:p-4 md:p-4 p-4">
            <h4
              class="text-dark fsize20 leading-6 mt-6 font-semibold lineclamp-1"
            >
              {{ i.title }}
            </h4>

            <p class="mt-1 fsize14 text-dark font-semibold">
              Date: <span class="font-normal">{{ getDate(i.createdAt) }}</span>
            </p>

            <!-- <div>
              <p
                class="mt-1 fsize14 text-dark font-semibold"
                v-if="i.hasOwnProperty('fileType') && i.fileType == 'Url'"
              >
                <span class="font-normal">{{ i.url }}</span>
              </p>
            </div> -->

            <div>
              <el-dialog
                :visible.sync="readMoreVisible"
                width="30%"
                :before-close="handleClose"
              >
                <span class="break-normal">{{ readMoreData }}</span>
              </el-dialog>
              <div class="h-12">
                <p
                  class="mt-1 fsize14 text-dark cursor-pointer font-normal lineclamp-2"
                >
                  {{ i.description }}
                  <!-- <span
                  v-if="i.description.length >= 40"
                  @click="handleReadMore(true, i)"
                  class="text-primary"
                  >read more</span
                > -->
                </p>
              </div>
            </div>

            <div class="flex items-center gap-2 justify-content-center">
              <b-button
                v-if="i.fileType == 'Video' || i.fileType == 'Image'"
                class="mt-2 border-2"
                variant="primary"
                @click="openFile(i)"
                >View</b-button
              >
              <b-button
                class="mt-2 border-2"
                variant="primary"
                @click="downloadPDF(i)"
                v-else-if="
                  i.hasOwnProperty('fileType') && i.fileType == 'Document'
                "
                >Download</b-button
              >
              <b-button
                v-else
                class="mt-2 border-2"
                variant="primary"
                @click="openFile(i)"
                >Read More</b-button
              >
            </div>
          </div>
        </div>
      </div>
      <div class="flex justify-end mt-4 w-full">
        <b-pagination
          v-model="currentPage"
          @change="
            (value) => {
              currentPage = value;
              getFutureTrendsData();
            }
          "
          :total-rows="pageCount"
          :per-page="9"
        ></b-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
export default {
  data() {
    return {
      readMoreVisible: false,
      tableData: [],
      // pagination
      currentPage: 1,
      pageCount: 0,
      readMoreData: "",
    };
  },
  methods: {
    handleReadMore(isRead, data) {
      this.readMoreVisible = isRead;
      this.readMoreData = data.description ? data.description : "";
    },
    getDate(date) {
      return moment(date).format("MMMM Do YYYY, h:mm a");
    },
    async handleOpenLink(URL) {
      let link = "";
      if (URL.includes("http")) {
        link = URL;
      } else {
        link = "https://" + URL;
      }
      window.open(link, "_blank");
    },
    async openFile(VALUE) {
      console.log(VALUE, "value");
      if (VALUE.fileType == "Document") {
        // await this.downloadPDF(VALUE);
        let link = `${this.$imageURL}/${VALUE.file}`;
        window.open(link, "_blank");
      } else if (VALUE.fileType == "Image") {
        let link = `${this.$imageURL}/${VALUE.file}`;
        window.open(link, "_blank");
      } else if (VALUE.fileType == "Video") {
        let link = `${this.$imageURL}/${VALUE.file}`;
        window.open(link, "_blank");
      } else if (VALUE.fileType == "Url") {
        // let link = `${this.$imageURL}/${VALUE.file}`;
        // window.open(link, "_blank");
        let link = "";
        if (VALUE.url.includes("http")) {
          link = VALUE.url;
        } else {
          link = "https://" + VALUE.url;
        }
        window.open(link, "_blank");
      }
    },
    async downloadPDF(VALUE) {
      let image_url = `${this.$imageURL}/${VALUE.file}`;
      let downloadImg = await axios.get(image_url, { responseType: "blob" });
      let imageBlog = new Blob([downloadImg.data]);
      const imageUrl = URL.createObjectURL(imageBlog);
      const link = document.createElement("a");
      link.href = imageUrl;
      link.download = "file.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    async getFutureTrendsData() {
      let offset = 0;
      let payload = {
        pagination: true,
      };

      if (this.currentPage == 1) {
        Object.assign(payload, { offset: offset });
      } else {
        offset = 9 * this.currentPage - 9;
        Object.assign(payload, { offset: offset });
      }
      if (this.search != "") {
        Object.assign(payload, { search: this.search });
      }
      let result = await this.$store.dispatch("ffc/getFutureTrends", payload);
      console.log(result, "RESULT");
      this.tableData = result.data.data;
      this.pageCount = result.data.count;
    },
  },
  async mounted() {
    await this.getFutureTrendsData();
  },
};
</script>
<style>
.headercolor .el-dialog__header {
  background: #4f0a4b !important;
}
.headercolor .el-dialog__title {
  color: white;
}
</style>
